type Props = {
  className?: string;
};

export const Unknown = (props: Props) => {
  return (
    <svg
      {...props}
      width={36}
      height={40}
      viewBox="0 0 45 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M44 27V47.75L14.7863 53L1.65649 40.5L1 19.5L30.2137 15L44 27Z"
        fill="#FEFCFB"
      />
      <path
        d="M14.7863 53V31.75M14.7863 53L44 47.75V27M14.7863 53L1.65649 40.5L1 19.5M14.7863 31.75L44 27M14.7863 31.75L1 19.5M44 27L30.2137 15L1 19.5"
        stroke="black"
        strokeWidth={0.656489}
      />
      <path
        d="M1.66667 40.75L15 53V32L1 20L1.66667 40.75Z"
        fill="black"
        fillOpacity={0.3}
      />
      <path
        d="M14.7863 31.9098V53L44 47.7895V27.4436L14.7863 31.9098Z"
        fill="black"
        fillOpacity={0.15}
      />
      <g filter="url(#filter0_d_2132_8743)">
        <rect
          x={10}
          y={3}
          width={24}
          height={24}
          rx={12}
          fill="#183EAF"
        />
        <rect
          x={10.375}
          y={3.375}
          width={23.25}
          height={23.25}
          rx={11.625}
          stroke="white"
          strokeWidth={0.75}
        />
        <path
          d="M16.3187 16.125C16.3187 16.125 16.0937 15.5625 16.0938 15C16.0938 14.4375 16.3188 13.875 16.3188 13.875M27.6813 13.875C27.6813 13.875 27.9063 14.4375 27.9062 15C27.9062 15.5625 27.6813 16.125 27.6813 16.125M23.1198 10.8486C23.1198 10.8486 23.7081 10.704 24.2651 10.7823C24.8222 10.8606 25.3479 11.1617 25.3479 11.1617M20.8794 19.1515C20.8794 19.1515 20.2911 19.296 19.734 19.2177C19.177 19.1394 18.6513 18.8383 18.6513 18.8383M18.6514 11.1617C18.6514 11.1617 19.1771 10.8606 19.7341 10.7823C20.2911 10.704 20.8795 10.8485 20.8795 10.8485M25.3481 18.8384C25.3481 18.8384 24.8224 19.1395 24.2653 19.2177C23.7083 19.296 23.12 19.1515 23.12 19.1515M20.3125 17.5312H23.6875C25.0855 17.5312 26.2188 16.398 26.2188 15C26.2188 13.602 25.0855 12.4687 23.6875 12.4687H20.3125C18.9145 12.4687 17.7812 13.602 17.7812 15C17.7812 16.398 18.9145 17.5312 20.3125 17.5312Z"
          stroke="white"
          strokeWidth={1.125}
          strokeLinecap="round"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_2132_8743"
          x={5}
          y={0}
          width={34}
          height={34}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood
            floodOpacity={0}
            result="BackgroundImageFix"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={2.5} />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.101961 0 0 0 0 0.101961 0 0 0 0 0.101961 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2132_8743"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2132_8743"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
